export default "__VITE_ASSET__B3hwf3$s__"